import { CanDeactivateFn } from '@angular/router';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CanDeactivateGuard: CanDeactivateFn<any> = (component) => {
  const unSavedChanges = component?.unSavedChanges;
  const confirmMessage = component?.confirmMessage;

  if (unSavedChanges) {
    const confirm = window.confirm(confirmMessage);
    if (!confirm) {
      return false;
    }
  }

  return true;
};
